<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1RAUTC/Images/StrumuscriptCover300w.jpg?1684514558611" alt="This image is the cover for the book Jazz Guitar Licks, Jazz Guitar Licks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jazz Guitar Licks, Jazz Guitar Licks
      </h1>
      <p class="bookDescription body article font2">
        <p>25 original jazz guitar licks from the Major scale and its modes in tablature and notation.<br/><br/> &gt;&gt; 117 bars of music over 25 licks (average lick length 4.68 bars)<br/> &gt;&gt; Video at full speed &amp; Audio at full &amp; half speed (Downloadable)<br/> &gt;&gt; Backing tracks at full and slower practise speeds (Downloadable)<br/> &gt;&gt; Scale diagrams with theory and technique tips for each lick<br/> &gt;&gt; Guitar tablature has picking directions &amp; fretting finger guide numbers<br/><br/> Please Note: This eBook haswritten music and is not suitable for smaller screens.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gareth Evans
      </h2>
      
      <p class="authorDescription body article">Gareth started learning guitar at age 8 and by age 10 was playing guitar in the orchestral pit with the teachers for school plays playing  guitar chords like Dom 9th, diminished and major 7th. At age 13 he achieved grade 5 classical guitar with honours. Later on Distinction at higher diploma level from the Academy of Contemporary music, grade 8 Electric guitar (RGT), grade 8 Electric guitar (RSL), grade 8 Contemporary Music Theory (LCM) and grade 8 Bass Guitar (RSL). He has his own guitar tuition practice where many of his students keep coming for years.<br><br>Understanding the needs of his students 1-1 helps decide what content to write in his Guitar Books. He decided there where ways things could be done differently, such as his “Guitar for Kids” book that doesn’t focus on sight-reading and uses mostly guitar tablature (like most guitar method books  do) or “Chords for Guitar” rather than giving you 1000’s of guitar chords, gives you shapes for various chord types that you can move up and down the fret-board.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ff0007a